const styles = theme => ({
  newPasswordContainer: {
    padding: theme.spacing(1)
  },
  passwordInputContainer: {
    width: 220
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/dialogs/ResetPassword/steps/NewPassword/styles.js